import { render, staticRenderFns } from "./BecomeHost.vue?vue&type=template&id=f6682420&scoped=true&"
import script from "./BecomeHost.vue?vue&type=script&lang=js&"
export * from "./BecomeHost.vue?vue&type=script&lang=js&"
import style0 from "./BecomeHost.vue?vue&type=style&index=0&id=f6682420&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6682420",
  null
  
)

export default component.exports